import React, { useState, useEffect } from "react";
import api from "../../../../../api";

const MembershipCard = ({ title, description, items }) => {
  const renderItem = (item) => {
    if (!item) return null;

    if (typeof item === "string") {
      return item;
    }

    const label = item.label || "";
    const url   = item.url || null;
    const file  = item.file || item.file_url || null;

    let href = null;

    if (url) {
      href = url;
    } else if (file) {
      href = `${process.env.REACT_APP_API_URL}/public${file}`;
    }

    if (!href || href.includes("null") || href.includes("undefined")) {
      return label;
    }

    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {label || href}
      </a>
    );
  };

  return (
    <div className="membership-card mx-auto p-4 p-md-5 shadow-lg rounded-4 text-white">
      <h2 className="text-center mb-4 text-white">{title}</h2>

      {description && <p dangerouslySetInnerHTML={{ __html: description }} />}

      <ul className="list-unstyled">
        {items?.map((item, index) => (
          <li key={index} className="mb-3">
            <i className="fa fa-book me-3"></i> {renderItem(item)}
          </li>
        ))}
      </ul>
    </div>
  );
};

const MembershipSection = () => {
  const [membershipData, setMembershipData] = useState(null);
  const [loading, setLoading] = useState(true);

  const toArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "object") {
      return Object.keys(value)
        .sort()
        .map((k) => value[k]);
    }
    return [value];
  };

  useEffect(() => {
    const fetchMembershipData = async () => {
      try {
        const response = await api.get("/api/sitepages/about-us/library");

        const membership = response.data.groups?.[5]?.membership_section || null;

        setMembershipData(membership);
      } catch (error) {
        console.error("Membership API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMembershipData();
  }, []);

  if (loading) return null;
  if (!membershipData) return null;

  const heading = membershipData.heading || "MEMBERSHIP";

  const membershipItems = toArray(membershipData.items);
  const repoItems       = toArray(membershipData.repo_items);

  const repoTitle       = membershipData.repo_title || "Repository";
  const repoDescription = membershipData.repo_description || "";

  return (
    <section id="membership">
      {/* DESKTOP VIEW */}
      <div className="container d-md-block d-none">
        <div className="row">
          <div className="col-md-6 col-sm-6 mx-auto">
            <MembershipCard
              title={membershipData.title}
              description={membershipData.description}
              items={membershipItems}
            />
          </div>

          {repoItems.length > 0 && (
            <div className="col-md-6 col-sm-6 mx-auto">
              <MembershipCard
                title={repoTitle}
                description={repoDescription}
                items={repoItems}
              />
            </div>
          )}
        </div>
      </div>

      {/* MOBILE VIEW */}
      <div className="container d-md-none d-block">
        <div className="sec-title text-center">
          <h2>{heading}</h2>
        </div>

        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-sm-10 mb-4">
            <MembershipCard
              title={membershipData.title}
              description={membershipData.description}
              items={membershipItems}
            />
          </div>

          {repoItems.length > 0 && (
            <div className="col-sm-10">
              <MembershipCard
                title={repoTitle}
                description={repoDescription}
                items={repoItems}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default MembershipSection;
